import { FC } from 'react'
import { t } from 'translations'

import styles from './divider.module.scss'

const Divider: FC<{ text: string; lng: 'en' | 'fr' }> = ({ text, lng }) => {
  return (
    <div className={styles['strike-divider']}>
      <span>{t(text, { lng })}</span>
    </div>
  )
}

export default Divider
